// Loadout Storefront client — proxies through the FastAPI backend so the
// Storefront token never leaves the server.  The public interface mirrors what
// a direct `@shopify/storefront-api-client` wrapper would expose, so any
// component only has to know the query verbs (productsList, productByHandle,
// collectionByHandle, ...).
//
// Deviation from spec: the spec mentions REACT_APP_SHOPIFY_STOREFRONT_TOKEN
// in a browser-side env; we deliberately keep the token backend-only for
// hardening.  Behaviour and API shape are identical.

import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const http = axios.create({
  baseURL: API_BASE,
  timeout: 20000,
});

// Health probe — used by /connection page and (optionally) a boot check.
export async function shopHealth() {
  const { data } = await http.get("/shopify/health");
  return data;
}
